import { createSelector } from 'reselect';
import * as validations from '../../lib/validation.utils';
import { capitalize } from 'lodash';

// STATE SELECTORS
const forms = state => state.admin.modalForms;
const modelForm = (state, props) => state.admin.modalForms[props.model];
const model = (state, props) => props.model;

export const formDataSelector = createSelector(modelForm, mf => mf || {});
export const formOpenSelector = createSelector(forms, f => f.open);
export const submittingSelector = createSelector(forms, f => f.submitting);
export const formErrorSelector = createSelector(forms, f => f.error);
export const fetchingDependenciesSelector = createSelector(forms, forms => forms.fetchingDependencies);
export const fetchedDependenciesSelector = createSelector(forms, forms => forms.fetchedDependencies);
export const dependenciesSelector = createSelector(forms, forms => forms.dependencies);
export const formsIsLoadingSelector = createSelector(forms, forms => forms.fetchingDependencies || forms.submitting);

export const canSubmit = createSelector(forms, model, modelForm, (forms, model, data) => {
    return forms.edited && !!validations[`validate${capitalize(model)}`](data);
});
